export default __webpack_public_path__ + "static/media/audio_52_fuegos_artificiales.52944c41.mp3";